import React, {Component} from "react";
import {
    CardSubtitle,
    Col,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row, Card, CardBody, Input
} from "reactstrap";
import Notify from "react-notification-alert";
import Select from "../../../local_node_modules/react-select";
import {request} from "../../../helper/APIUtils";
import {defterUnitName, defterUnitNameShort} from "../../../helper/permission";
import {EntegratorConf} from "../../../constants";
import Alert from "react-s-alert";
import {showAxiosError} from "../../../helper/helper";
import AutoCompleteList from "../../../components/AutoCompleteList";
import moment from "moment";
import ReactLoading from "react-loading";
import NumberFormat from "react-number-format";
import Table from "../../../components/Table/Table";



class CreditSalesByDistributorModal extends Component {

    constructor(props) {
        super(props);
        this.state =
            {
                total: 0,
                page: 0,
                size: 5,
                manual: false,
                content: [],
                distributorList:[],
                distributorCreditSale: {
                    distributorId:"",
                    unit: null,
                    quantity: null,
                },
                leftPage:"",
                leftPcs:"",
                leftArchiveBox:"",
                loading: false,
                saveLoading: false,
                loadingSummaryInfo:false,
                tolerateDay: 0,
            };
        this.modifyDate = this.modifyDate.bind(this);
        this.getCreditInfo= this.getCreditInfo.bind(this);
        this.unitTypeList = this.unitTypeList.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.onDistributorChange = this.onDistributorChange.bind(this);
        this.getCreditHistory = this.getCreditHistory.bind(this);
    }

    componentDidMount() {
        this.getSubDistributors();
        this.getCreditInfo();
    }

    onDistributorChange(e) {
        this.setState((prevState) => ({
            distributor: e.value,
            distributorCreditSale: {
                ...prevState.distributorCreditSale,
                distributorId: e.value
            }
        }));
    }

    onValueChange(value, fieldName) {

        if(fieldName === "unit"){
            this.setState((prevState) => ({
                distributorCreditSale: {
                    ...prevState.distributorCreditSale,
                    [fieldName]: value,
                    quantity: null
                }
            }));
        } else {
            this.setState((prevState) => ({
                distributorCreditSale: {
                    ...prevState.distributorCreditSale,
                    [fieldName]: value
                }
            }));
        }

    }

    getSubDistributors() {
        let self = this;
        let params = {
            url: `/customer/getSubDistributors`,
            method: "get"
        };
            request(params)
                .then(function (response) {self.setState({distributorList: response.data});
                }).catch(function (error) {
                showAxiosError(error);
            });
    }

    getCreditInfo(){
        let self = this;
        let params = {
            url: `/customer/getCreditSalesForDistributors`,
            method: "get"
        };
        self.setState({loadingSummaryInfo: true});
        request(params)
            .then(function (response) {console.log("response", response);
                const data = response.data;
                self.setState({leftPage: data.leftPage, leftPcs: data.leftPcs, leftArchiveBox: data.leftArchiveBox, loadingSummaryInfo:false });
            }).catch(function (error) {
            self.setState({loadingSummaryInfo: false});
            showAxiosError(error);
        });
    }

    getCreditHistory(accessor, direction,page, size){
        let self = this;
        let data = self.props.currentUser ? self.props.currentUser.customerId : '';
        let params = {
            url: `/customer/getDistributorCreditSaleHistory`+ '?page=' + page + '&size=' + size,
            method: "post",
            data: data
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                const data = response.data;
                self.setState({
                    content: data.content,
                    manual: false,
                    loading: false,
                    page: page,
                    size: size,
                    total: response.data.totalElements
                });
            }).catch(function (error) {
            self.setState({manual: false, loading: false})
            showAxiosError(error);
        });
    }

    unitTypeList() {
        return [
            {value: 0, label: "Seçiniz..."},
            {value: 1, label: "Kontör"},
            {value: 2, label: defterUnitName(EntegratorConf.identifier)},
            {value: 3, label: "Arşiv Kasa"}
        ]
    }

    unitTypeExpr(unitType) {
        return (unitType === 1 || unitType === 3) ? "Adet" : (defterUnitNameShort(EntegratorConf.identifier))
    }

    validateFields() {
        let errorMessage = "";
        let {distributorCreditSale} = this.state;
        if(distributorCreditSale["distributorId"] === "" || distributorCreditSale["distributorId"] === null){
            errorMessage += "<strong>" + ("Bayi alanı boş bırakalamaz.") + "</strong><br/>";
        }
        if(distributorCreditSale["unit"] === 0 || distributorCreditSale["unit"] === null){
            errorMessage += "<strong>" + ("Birim Türü alanı boş bırakalamaz.") + "</strong><br/>";
        }
        if(distributorCreditSale["quantity"] === 0 || distributorCreditSale["quantity"] === null || distributorCreditSale["quantity"] === ""){
            errorMessage += "<strong>" + ("Birim Miktarı alanı boş bırakalamaz.") + "</strong><br/>";
        }
        return errorMessage;
    }

    onSave(){
        let errorMessage = this.validateFields();
        if(errorMessage !== ""){
            Alert.error(errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }else{
            let self = this;
            let params = {
                url:"/customer/saveDistributorCreditSale",
                method: "post",
                data: self.state.distributorCreditSale
            };
            self.setState({saveLoading: true});
            request(params)
                .then(function () {
                    Alert.success("Başarı ile kaydedildi", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000,
                        html: false
                    });
                    self.setState(() => ({
                        distributorCreditSale: {
                            distributorId:"",
                            unit: 0,
                            quantity: 0,
                        },
                        distributor:"",
                        leftPage: "",
                        leftPcs: "",
                        leftArchiveBox: "",
                        saveLoading: false
                    }));
                    self.getCreditInfo();
                    self.getCreditHistory("","",self.state.page,self.state.size);

                }).catch(function (error) {
                showAxiosError(error);
                self.setState({saveLoading: false});
                })

        }
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY');
    }

    defineCreditUnit(data) {
        switch (data.unit) {
            case 1:
                return ['Adet', 'Kontör Adedi'];
            case 2:
                return [defterUnitNameShort(EntegratorConf.identifier), defterUnitName(EntegratorConf.identifier)];
            case  3:
                return ['E-Arşiv Kasa', 'E-Arşiv Kasa Adedi'];
        }
    }

    render() {
        let {unit,quantity} = this.state.distributorCreditSale;
        const {content, isMobile} = this.state;
        let columns = [
            {
                Header: "Bayi Kodu",
                title: "Bayi Kodu",
                accessor: "distributorId",
                sortable: false
            },
            {
                Header: "Bayi Adı",
                title:"Bayi Adı",
                accessor: "distributorName",
                sortable: false,
            },
            {
                Header: "Birim",
                title: "Birim",
                accessor: "unit",
                sortable: false,
                Cell: row => (
                    <label>{row.count} {this.defineCreditUnit(row)[1]}</label>
                )
            },
            {
                Header: "Birim Miktar",
                title: "Birim Miktar",
                accessor: "quantity",
                sortable: false,
            },
            {
                Header: "Oluşturulma Tarihi",
                title: "Oluşturulma Tarihi",
                accessor: "createdAt",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.createdAt)}</label>
                )
            },
        ];
        return (
            <Modal isOpen={this.props.isOpen} keyboard={true} size="lg">
                <Notify ref="notify"/>
                <ModalHeader toggle={this.props.toggle}>Bayi Kontör Dağıtımı</ModalHeader>
                <ModalBody>
                    <Card style={{borderColor: "#bbd7ea", borderWidth: "2px", borderStyle: "solid"}}>
                        <div style={{padding: '5px 15px', backgroundColor: "#bbd7ea"}}>
                            <CardSubtitle style={{margin: 0, color: "white", textTransform: "capitalize"}}>Geçmiş Dağılım Özeti</CardSubtitle>
                        </div>
                            <Table columns={columns}
                                   content={content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   size={this.state.size}
                                   loading={this.state.loading}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.getCreditHistory}
                                   manual={this.state.manual}
                            />
                    </Card>

                    {this.props.currentUser && this.props.currentUser.parentCustomerId === 1 &&
                    <Card style={{borderColor: "#bbd7ea", borderWidth: "2px", borderStyle: "solid" }}>
                        <div style={{padding: '5px 15px', backgroundColor: "#bbd7ea"}}>
                            <CardSubtitle style={{margin: 0, color: "white", textTransform: "capitalize"}}>Kalan Kredi Özeti</CardSubtitle>
                        </div>
                        <Row style={{paddingBottom: '2%', padding:"0px 15px", color:"green"}}>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Kalan Sayfa :
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                {this.state.loadingSummaryInfo === true ?
                                <ReactLoading type="spinningBubbles"
                                              style={{
                                                  width: "10px",
                                                  height: "10px",
                                                  margin: "20px auto 0 auto",
                                                  fill: "#888"
                                              }}/> : (this.state.leftPage)}
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Kalan Kontör :
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                {this.state.loadingSummaryInfo === true ?
                                <ReactLoading type="spinningBubbles"
                                              style={{
                                                  width: "10px",
                                                  height: "10px",
                                                  margin: "20px auto 0 auto",
                                                  fill: "#888"
                                              }}/> : (this.state.leftPcs)}
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                Kalan Arşiv Kasa :
                            </Col>
                            <Col xs='12' sm='12' md='6' lg='6' xl='6'>
                                {this.state.loadingSummaryInfo === true ?
                                    <ReactLoading type="spinningBubbles"
                                                  style={{
                                                      width: "10px",
                                                      height: "10px",
                                                      margin: "20px auto 0 auto",
                                                      fill: "#888"
                                                  }}/> : (this.state.leftArchiveBox)}
                            </Col>
                        </Row>
                    </Card>
                    }

                    {this.props.currentUser && this.props.currentUser.parentCustomerId === 1 &&
                        <Card style={{marginTop: '10px', borderColor: "#bbd7ea", borderWidth: "2px", borderStyle: "solid"}}>
                            <div style={{padding: '5px 15px 20px', backgroundColor: "#bbd7ea"}}>
                                <CardSubtitle style={{margin: 0, color: "white", textTransform: "capitalize"}}>Kredi Yükleme Formu</CardSubtitle>
                            </div>

                            <CardBody className={"fatura-type-card-body"}>
                                <Form>
                                    <Row form="true" style={{padding: '10px 0px 10px'}}>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label for="distributorId">Bayi Seçimi</Label>
                                                <AutoCompleteList
                                                    name={"Bayi Seçme"}
                                                    useUpperCase={false}
                                                    allowNew={false}
                                                    list={this.state.distributorList.map(cs => ({
                                                        value: cs.recordId,
                                                        label: cs.distributorName
                                                    }))}
                                                    value={this.state.distributor}
                                                    onChange={e => this.onDistributorChange(e)}
                                                    placeholder="Bayi seçiniz...."
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label for="unit">Birim Türü</Label>
                                                <Select id="unit"
                                                        name="unit"
                                                        value={unit}
                                                        clearable={false}
                                                        placeholder="Seçiniz..."
                                                        noResultsText="Kayıt bulunamadı."
                                                        onChange={e => this.onValueChange(e.value,"unit")}
                                                        options={this.unitTypeList()}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row form="true" style={{padding: '10px 0px 10px'}}>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label for="quantity">Birim Miktarı <span
                                                    style={{color: "crimson"}}>({this.unitTypeExpr(unit)})</span>
                                                </Label>
                                                <NumberFormat
                                                    id="creditsalesdistributorquantity"
                                                    name="quantity"
                                                    value={quantity}
                                                    allowNegative={false}
                                                    isNumericString={true}
                                                    allowEmptyFormatting={true} // Allow empty formatting
                                                    decimalScale={0}
                                                    thousandSeparator={'.'}
                                                    decimalSeparator={','}
                                                    displayType="input"
                                                    isAllowed={(values) => {
                                                        return values.value === "" || !isNaN(values.floatValue); // Allow empty or valid number
                                                    }}
                                                    placeholder="Lütfen birim miktarı giriniz...."
                                                    renderText={(value) => value.replace(/\./g, ',')} // Return the modified value
                                                    onValueChange={(e) => this.onValueChange(e.value, "quantity")}
                                                    className="form-control"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                    </Card>
                    }
                </ModalBody>
                {this.state.saveLoading ? (
                    <ReactLoading type="spinningBubbles"
                                  style={{
                                      width: "30px",
                                      height: "30px",
                                      margin: "30px auto 0 auto",
                                      fill: "#bbd7ea"
                                  }}/>
                ) :  (<ModalFooter>
                            <button type="button"
                                    onClick={this.props.toggle}
                                    className=" TekBtn vazgec"
                                    style={{
                                        background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                        padding: '9px 45px 9px 20px'
                                    }}
                                    disabled={this.state.saveLoading}
                            >Vazgeç
                            </button>
                            <button type="button"
                                    onClick={this.onSave}
                                    style={{padding: '9px 45px 9px 20px'}}
                                    disabled={this.state.saveLoading}
                                    className="  TekBtn kaydet pull-right"
                            >Yükle</button>
                </ModalFooter>)}
            </Modal>
        )
    }
}

export default CreditSalesByDistributorModal;